module.exports = __webpack_public_path__ + "static/smoothweb-logo-full-566e38262666a0e936b0471911b41701.png";